var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddstudymaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.426 22.5912C104.471 20.9424 103.104 19.5684 101.458 18.6032C99.8113 17.638 97.9422 17.1145 96.0325 17.0839H25.3066L22.1018 4.63726C21.778 3.43577 21.0557 2.37894 20.0523 1.63891C19.049 0.898872 17.8238 0.519234 16.5764 0.561824H5.52546C4.06002 0.561824 2.65459 1.14206 1.61837 2.17489C0.582145 3.20772 0 4.60854 0 6.06918C0 7.52982 0.582145 8.93063 1.61837 9.96346C2.65459 10.9963 4.06002 11.5765 5.52546 11.5765H12.377L27.6273 68.082C27.9511 69.2835 28.6735 70.3403 29.6768 71.0803C30.6801 71.8204 31.9053 72.2 33.1528 72.1574H82.8819C83.9023 72.1543 84.9018 71.8697 85.7698 71.335C86.6379 70.8004 87.3404 70.0366 87.7995 69.1284L105.923 33.0001C106.709 31.359 107.074 29.5496 106.987 27.7334C106.901 25.9171 106.364 24.1505 105.426 22.5912ZM79.4561 61.1427H37.3521L28.3456 28.0986H96.0325L79.4561 61.1427Z",
    fill: "#FBBD74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3741 99.6978C34.9516 99.6978 38.6623 95.9993 38.6623 91.4368C38.6623 86.8744 34.9516 83.1758 30.3741 83.1758C25.7967 83.1758 22.0859 86.8744 22.0859 91.4368C22.0859 95.9993 25.7967 99.6978 30.3741 99.6978Z",
    fill: "#FBBD74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6398 99.6978C90.2172 99.6978 93.9279 95.9993 93.9279 91.4368C93.9279 86.8744 90.2172 83.1758 85.6398 83.1758C81.0623 83.1758 77.3516 86.8744 77.3516 91.4368C77.3516 95.9993 81.0623 99.6978 85.6398 99.6978Z",
    fill: "#FBBD74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddstudymaterial);
export default __webpack_public_path__ + "static/media/addstudymaterial.6393f75b5baa05fc98f5d6b56bbb179b.svg";
export { ForwardRef as ReactComponent };